import { FC } from 'react'

import { LoadingSpinner, PayrollPeriodNavigator } from '@/components'
import { EmployeeSaldoGroup } from '@/compositions'
import { UserWithHourBalances } from '@/entities/HourBalances/HourBalances'
import { PayrollPeriod } from '@/models'

import './EmployeeBalancesPerPeriod.scss'


interface EmployeeBalancesPerPeriodProps {
    loading: boolean
    activePayrollPeriod: PayrollPeriod
    className?: string
    hourBalances?: UserWithHourBalances
    switchPayrollPeriod: (nextPeriod: boolean) => void
}

export const EmployeeBalancesPerPeriod: FC<EmployeeBalancesPerPeriodProps> = ({
    loading,
    activePayrollPeriod,
    hourBalances,
    switchPayrollPeriod,
}) => (
    <div className="employee-balances-per-period">
        {loading && <LoadingSpinner />}
        <PayrollPeriodNavigator
            className="loket-balances-per-period__period-navigator"
            payrollPeriod={activePayrollPeriod}
            switchPayrollPeriod={switchPayrollPeriod}
        />
        {hourBalances && <EmployeeSaldoGroup {...hourBalances} />}
    </div>
)
